import { useTheme } from '../hooks/useTheme';
import './ThemeToggle.css';

export default function ThemeToggle() {
    const { effective, toggle } = useTheme();
    const isDark = effective === 'dark';
    return (
        <button
            type="button"
            className="theme-toggle"
            onClick={toggle}
            aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
            aria-pressed={isDark}
            title={isDark ? 'Light theme' : 'Dark theme'}
        >
            <span aria-hidden="true" className="theme-toggle__icon">
                {isDark ? '☀' : '☾'}
            </span>
        </button>
    );
}
